import ShowLoader from "@/components/Loader";
import ScrollToTop from "@/components/ScrollToTop";
import Toaster from "@/components/Toaster";
import { deleteCustomRfqFile, fetchRFQProduct, generateRfqQuotation, getCustomRfqFile, getPriceVrientVendor, getRfqById, getRfqSummary, removeRfqItems, saveRfqProductMargin, updateProductQuantity } from "@/store/slices/rfqSlice";
import { CurrencyRupeeIcon, EllipsisVerticalIcon, MagnifyingGlassPlusIcon, MinusIcon, PencilIcon, PlayCircleIcon, PlusIcon } from "@heroicons/react/24/solid";
import {
    Avatar,
} from "@material-tailwind/react";
import { Tooltip } from "@material-tailwind/react";
import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Popover } from 'react-tiny-popover';
import React from "react";
import {
    Typography,
    Button,
    IconButton
} from "@material-tailwind/react";
import Swal from "sweetalert2"
import { ChevronDownIcon, EyeIcon, CheckBadgeIcon, FunnelIcon, MagnifyingGlassIcon, PencilSquareIcon, TrashIcon, XCircleIcon, InformationCircleIcon, ClockIcon, ChatBubbleOvalLeftEllipsisIcon, Bars3BottomLeftIcon, PlusSmallIcon } from "@heroicons/react/24/solid";
import { installationCharge } from "../../store/slices/rfqSlice";
import DocumentViewModal from "@/components/DocumentViewModal";
import VendorVarientPriceModal from "./rfq-modals/vendor-varient-price-modal";
import { Popover as MaterialPopover, PopoverHandler, PopoverContent } from "@material-tailwind/react";
import useHasPermission from "@/components/useHasPermission";
import ProductVariantSelector from "../products/product-varients";
import { getSettingData } from "@/store/slices/settingSlice";
import UpdatePriceModal from "./rfq-modals/update-price-modal";
import ViewVendorVarientPriceModal from "./rfq-modals/view-vendor-varient-price-modal";
import ViewAssignedMembers from "../orders/order-modals/view-assigned-members";
import { useTranslation } from "react-i18next";

export function RfqItems({ rfq_id, rfq_data, search = '' }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // Track per-item quantity while user is editing; keyed by rfq_product id
    const [productQuantity, setProductQuantity] = useState({});
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [documentUrl, setDocumentUrl] = useState('_');
    const [sortingOrder, setSortingOrder] = useState('');
    const [isSortingPopoverOpen, setIsSortingPopoverOpen] = useState(false);
    const [isCheckedItemPopoverOpen, setIsCheckedItemPopoverOpen] = useState(false);
    const [checkedAction, setCheckedAction] = useState('');
    const [checkedItems, setCheckedItems] = useState([]);
    const hasUpdatePermission = useHasPermission(`rfq.update`);
    const hasDeletePermission = useHasPermission(`rfq.delete`);
    const hasViewProductPermission = useHasPermission(`product.view`);
    const hasUpdateProductPermission = useHasPermission(`product.update`);

    const [actionMenuOptions, setActionMenuOptions] = useState([]);
    const [openModalViewVendor, setOpenModalViewVendor] = useState(false);
    const [openModalEditVendor, setOpenModalEditVendor] = useState(false);
    const hasViewVendorPermission = useHasPermission(`assign-vendor.view`);
    const hasEditVendorPermission = useHasPermission(`assign-vendor.add`) || useHasPermission(`assign-vendor.update`);
    const hasViewProductPurchasePricePermission = useHasPermission(`product-purchase-price.view`);
    const hasViewProductSalePricePermission = useHasPermission(`product-sale-price.view`);

    const [selectedItemData, setSelectedItemData] = useState(null);
    const { t } = useTranslation('rfq');
    const { t: ct } = useTranslation("common");

    const { user } = useSelector((state) => state.user);

    const [isMemberShow, setIsMemberShow] = useState(false);

    const sorting_options = [
        {
            label: t('sort_ascending'),
            value: 'asc'
        },
        {
            label: t('sort_descending'),
            value: 'desc'
        },
    ];


    const { rfq_details, rfq_products, custom_rfq_files, loading, list_loading, rfq_summary } = useSelector((state) => state.rfq);

    useEffect(() => {
        dispatch(getCustomRfqFile(rfq_id));
    }, []);

    useEffect(() => {
        if (rfq_id) dispatch(getRfqById(rfq_id));
    }, [rfq_id]);

    useEffect(() => {
        let options = [{
            label: t('remove_selected_items'),
            value: 'remove'
        }];

        // if (
        //     rfq_data?.admin_approval === 'yes' &&
        //     !options.some(
        //         (option) => option.value === 'generate_quotation'
        //     )
        // ) {
        //     options.push({
        //         label: t('generate_quotation_pdf'),
        //         value: 'generate_quotation',
        //     });
        // }

        // if (
        //     !options.some(
        //         (option) => option.value === 'generate_quotation'
        //     )
        // ) {
        //     options.push({
        //         label: t('generate_quotation_pdf'),
        //         value: 'generate_quotation',
        //     });
        // }

        setActionMenuOptions(options);

    }, [rfq_details]);

    useEffect(() => {
        dispatch(fetchRFQProduct({ rfq_id: rfq_id, search: search, sort_order: sortingOrder }));
    }, [sortingOrder]);

    const handelSorting = (value) => {
        setSortingOrder(value);
    }

    // Increment / decrement helper (delta-based) and trigger update when value really changes
    const handleQuantityChange = (id, quantity, delta, item) => {
        if (isEditingRestricted) {
            return;
        }
        if (rfq_details?.customer_approval === 'yes') {
            Toaster.error(t('quantity_update_denied'));
            return;
        }
        setProductQuantity((prev) => {
            const current = Number(prev[id] ?? quantity) || 0;
            const next = Math.max(1, current + delta);

            // Fire API only when value actually changes from original quantity
            if (next !== quantity) {
                updateQuantity(id, next, item);
            }

            return {
                ...prev,
                [id]: next,
            };
        });
    };

    const updateQuantity = (id, quantity, item) => {
        if (!hasUpdatePermission) {
            Toaster.error(ct("noPermission"));
            return;
        };
        dispatch(updateProductQuantity({ item_id: id, quantity: quantity })).unwrap().then((res) => {
            dispatch(fetchRFQProduct({ rfq_id: rfq_id, search: search, sort_order: sortingOrder }));
            Toaster.success(t('quantity_updated_success'));
            dispatch(getRfqSummary(rfq_id));
            dispatch(getRfqById(rfq_id));
            // add_vendor_varient_price(item);
        }).catch((error) => {
            console.error("Delete failed:", error);
        });
    }

    const addItem = () => {
        if (!hasUpdatePermission && !hasViewProductPermission && !hasUpdateProductPermission) {
            Toaster.error(ct("noPermission"));
            return;
        };
        if (rfq_data?.user_id === null) {
            Toaster.error(t("createCustomerFirstError"));
            return;
        }
        navigate("/dashboard/products", {
            state: {
                rfq_id: rfq_id,
                rfq_reference: rfq_data?.rfq_reference,
                customer_id: rfq_data?.customer?.id,
                customer_delivery_address: rfq_summary?.customer_delivery_address ?? rfq_data?.customer_delivery_address ?? '',
                latitude: rfq_summary?.latitude ?? rfq_data?.latitude ?? null,
                longitude: rfq_summary?.longitude ?? rfq_data?.longitude ?? null,
                material_submittal: rfq_data?.material_submittal,
                rfq_type: rfq_data?.type
            },
        });
    };

    const [isPopoverOpen, setIsPopoverOpen] = useState([]);
    const openActionPopover = (id) => {
        setIsPopoverOpen((prev) => {
            if (prev.includes(id)) {
                return [];
            } else {
                return [id];
            }
        });
    };
    const [isPopoverOpen2, setIsPopoverOpen2] = useState([]);
    const openActionPopover2 = (index) => {
        setIsPopoverOpen2((prev) => {
            if (prev.includes(index)) {
                return [];
            } else {
                return [index];
            }
        });
    };

    const popoverRef = useRef(null);
    useEffect(() => {
        function handleClickOutside(e) {
            if (popoverRef.current && !popoverRef.current.contains(e.target)) {
                setIsPopoverOpen([]);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const popoverRef2 = useRef(null);
    useEffect(() => {
        function handleClickOutside(e) {
            if (popoverRef2.current && !popoverRef2.current.contains(e.target)) {
                setIsPopoverOpen2([]);
            }
        }
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleSingleCheck = (value) => {
        if (checkedItems.includes(value)) {
            setCheckedItems(checkedItems.filter((v) => v !== value));
        } else {
            setCheckedItems([...checkedItems, value]);
        }
    };

    const handleCheckAll = (e) => {
        if (e.target.checked) {
            const ids = rfq_products?.map((row) => row.id) || [];
            setCheckedItems(ids);
        } else {
            setCheckedItems([]);
        }
    };

    const isAllChecked =
        rfq_products?.length > 0 &&
        checkedItems?.length === rfq_products?.length;

    const handelCheckedItems = (action) => {
        setCheckedAction(action);
        setIsCheckedItemPopoverOpen(false);
        if (checkedItems?.length) {
            if (action === 'generate_quotation') {
                if (checkedItems.length !== rfq_products.length) {
                    Toaster.error(t('select_all_for_quotation', { count: rfq_products.length }));
                    return;
                }

                Swal.fire({
                    title: ct("areYouSure"),
                    html: `
                        <p style="font-size:20px; color:#555; margin-bottom:8px;">
                        ${ct("generateQuotationConfirmation")}
                        </p>
                        <p style="font-size:18px; color:#777;">
                        ${t('apply_customer_price_note')}
                        </p>
                    `,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: t('generate_button')
                }).then((result) => {
                    if (result.isConfirmed) {
                        dispatch(generateRfqQuotation({ rfq_product_ids: checkedItems })).unwrap().then((res) => {
                            if (res?.status) {
                                downloadQuotation(res?.file_url);
                                Toaster.success(t('quotation_generated_success'));
                                setCheckedAction('');
                                dispatch(fetchRFQProduct({ rfq_id: rfq_id, search: search, sort_order: sortingOrder }));
                            } else {
                                Toaster.error(res?.message || ct("somethingWentWrong"));
                            }
                        }).catch((error) => {
                            Toaster.error(t('quotation_generation_failed'));
                        });
                    }
                });
            } else {
                if (rfq_products?.length === 1) {
                    Toaster.error(t('cannot_remove_all_items'));
                    return;
                }
                Swal.fire({
                    title: ct("areYouSure"),
                    text: t("performActionConfirmation"),
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes"
                }).then((result) => {
                    if (result.isConfirmed) {
                        dispatch(removeRfqItems({ items_id: checkedItems })).unwrap().then((res) => {
                            Toaster.success(checkedItems?.length > 1 ? t('items_removed_success') : t('item_removed_success'));
                            setCheckedItems([]);
                            setCheckedAction('');
                            dispatch(fetchRFQProduct({ rfq_id: rfq_id, search: search, sort_order: sortingOrder }));
                        }).catch(() => {
                            Toaster.error(ct("actionFailed"));
                        });
                    }
                });
            }
        } else {
            Toaster.error(t('select_item_for_action'));
        }
    }

    const openUpdateModal = (item) => {
        if (!hasUpdatePermission) {
            Toaster.error(ct("noPermission"));
            return;
        }
        if (!item?.vendor_price) {
            Toaster.error(t('add_vendor_price_before_edit'));
            return;
        }
        setSelectedItemData(item);
    };

    const closeUpdateModal = () => {
        setSelectedItemData(null);
    };

    const downloadQuotation = (file_url) => {
        const link = document.createElement("a");
        link.target = "_blank";
        link.href = file_url;
        link.download = "quotation.pdf";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    const delete_item = (id) => {
        if (rfq_products?.length === 1) {
            Toaster.error(t('cannot_remove_all_items'));
            return;
        }
        Swal.fire({
            title: ct("areYouSure"),
            text: t("removeItemConfirmation"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: ct("yesDelete")
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeRfqItems({ items_id: id })).unwrap().then((res) => {
                    Toaster.success(t('item_removed_success'));
                    dispatch(fetchRFQProduct({ rfq_id: rfq_id, search: search, sort_order: sortingOrder }))
                        .unwrap()
                        .then(() => {
                            dispatch(getRfqSummary(rfq_id));
                            dispatch(getRfqById(rfq_id));
                        });
                }).catch((error) => {
                    Toaster.error(t("removeFailedError"));
                });
            }
        });
    }

    const isInstallationCharge = (event, id) => {
        if (!hasUpdatePermission) {
            Toaster.error(ct("noPermission"));
            return;
        };
        if (rfq_details?.customer_approval === 'yes') {
            Toaster.error(t('installation_charge_update_denied'));
            return;
        }
        const value = event.target.checked ? 'yes' : 'no';
        dispatch(installationCharge({ type: 'single', items_id: id, is_installation: value })).unwrap().then((res) => {
            // Toaster.success(t('installation_charge_update_success', { status: value === 'yes' ? ct('added') : ct('removed') }));
            let newStatus = value === 'yes' ? t('added') : t('removed');
            Toaster.success(t("installation_charge_update_success", { status: newStatus }));
            dispatch(fetchRFQProduct({ rfq_id: rfq_id, search: search }));
            dispatch(getRfqSummary(rfq_id));
            // dispatch(getRfqById(rfq_id));

        }).catch((error) => {
            Toaster.error(ct("actionFailed"));
        });
    }

    const delete_rfq_file = (index) => {
        if (custom_rfq_files?.files?.length === 1) {
            Toaster.error(t('cannot_delete_all_files'));
            return;
        }
        Swal.fire({
            title: ct("areYouSure"),
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: ct("yesDelete")
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(deleteCustomRfqFile({ index, rfq_id })).unwrap().then((res) => {
                    if (res?.status) {
                        Toaster.success(t('file_deleted_success'));
                        setIsPopoverOpen2([]);
                        dispatch(getCustomRfqFile(rfq_id));
                    } else {
                        Toaster.error(res.message);
                    }
                }).catch((error) => {
                    console.error("Delete failed:", error);
                    Toaster.error(ct("deleteFailedError"));
                });
            }
        });
    }

    const handleDownload = async (e, fileName, fileUrl) => {
        e.preventDefault();

        try {
            const response = await fetch(fileUrl, {
                method: 'GET',
                headers: {}
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');

            link.href = url;
            link.download = fileName; // Use the safe variable here

            document.body.appendChild(link);
            link.click();

            // Cleanup
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Download failed:', error);
            // Fallback: Open in new tab if the fetch fails
            window.open(fileUrl, '_blank');
        }
    }

    const userRole = user?.roles?.[0] || "";
    const isMember = user?.parent_id != null || user?.designation?.toLowerCase() === "member";
    const isAdminRole = userRole === "Administrator" || userRole === "Sub Admin";

    const isDataReady =
        !!user?.roles?.length &&
        !!rfq_details?.id &&
        String(rfq_details.id) === String(rfq_id);

    const isAdminApproved = rfq_details?.admin_approval === 'yes';
    const isCustomerApproved = rfq_details?.customer_approval === 'yes';

    const isSalesMemberBlocked = isMember && userRole === "Sales Representative" && rfq_details?.sales_representative_approval === 'yes';
    const isProcurementMemberBlocked = isMember && userRole?.startsWith("Procurement") && rfq_details?.procurement_manager_approval === 'yes';

    const isProcurementAssigned = rfq_details?.assigned_details?.some((i) => i?.type === "Procurement");
    const isProcurementSentBack = rfq_details?.is_procurement_rejected === 'yes';
    const isSalesManager = !isMember && userRole === "Sales Representative";
    // const isSalesManagerBlocked = isSalesManager && isProcurementAssigned && !isProcurementSentBack;
    // to disable some fields of sales member and manager when RFQ approved by manager 
    const isSalesManagerBlocked = isSalesManager && (
        rfq_details?.sales_representative_approval === 'yes' || 
        (isProcurementAssigned && !isProcurementSentBack)
    );
    const isSentToAdmin = rfq_details?.is_send_to_admin != null;
    const isAdminRejected = rfq_details?.admin_approval === 'no';
    const isProcurementManager = !isMember && userRole?.startsWith("Procurement");
    // const isProcurementManagerBlocked = isProcurementManager && isSentToAdmin && !isAdminRejected;
    // to disable some fields of procurement member and manager when RFQ approved by manager
    const isProcurementManagerBlocked = isProcurementManager && (
        rfq_details?.procurement_manager_approval === 'yes' || 
        (isSentToAdmin && !isAdminRejected)
    );
    const isEditingRestricted = !isDataReady || (
        isAdminRole
            ? isCustomerApproved
            : (
                isAdminApproved ||
                isCustomerApproved ||
                isSalesMemberBlocked ||
                isProcurementMemberBlocked ||
                isSalesManagerBlocked ||
                isProcurementManagerBlocked
            )
    );
    
    return (
        <div className="rounded-lg mt-5">
            {loading && <ShowLoader />}
            <ScrollToTop />

            {rfq_data?.type === 'custom' &&
                <div className="px-4 md:px-6">

                    <div>
                        <h2 className="text-lg font-semibold text-gray-800 mb-2 flex items-center gap-2">
                            {t('description_label')}
                        </h2>
                        <p className="text-gray-800 leading-relaxed text-sm">
                            {custom_rfq_files?.comment}
                        </p>
                    </div>
                    <div className="mt-5 mb-10">
                        <div className="flex items-center pb-4 mb-2 border-b border-gray-100">
                            {/* {hasUpdatePermission && <input
                                type="checkbox"
                                className="h-5 w-5 text-black border-gray-300 rounded cursor-pointer focus:ring-black"
                                onChange={(e) => handleCheckAll(e)}
                                checked={isAllChecked}
                            />} */}
                            <h3 className="ml-3 text-base font-medium">
                                {t('uploaded_files_label')} ({custom_rfq_files?.files?.length})
                            </h3>
                        </div>

                        <div className="space-y-2">
                            {custom_rfq_files?.files?.map((file, index) => (
                                <div key={index} className="flex items-center justify-between py-3 border-b border-gray-300 last:border-b last:border-gray-300">
                                    <div className="flex items-center flex-grow">
                                        {/* <input
                                            type="checkbox"
                                            // checked={file.checked}
                                            // onChange={() => handleFileCheck(file.id)}
                                            className="h-5 w-5 text-black border-gray-300 rounded cursor-pointer focus:ring-black"
                                        /> */}
                                        <img src={`/img/icons/surface1.png`} alt='Downloadable' className="h-7 w-7 object-contain ml-3 p-1" />

                                        <p className="ml-3 text-sm text-gray-800">{file.file_name}</p>
                                    </div>

                                    <div className="flex items-center space-x-2">
                                        {file?.url && (
                                            <Tooltip content={t('view_button')}>
                                                <IconButton
                                                    variant="text"
                                                    color="blue-gray"
                                                    size="sm"
                                                    onClick={() => {
                                                        setIsModalOpen(true);
                                                        setDocumentUrl(file?.url);
                                                    }}
                                                    className="rounded-full text-gray-600 hover:text-blue-600 hover:bg-blue-50"
                                                >
                                                    <EyeIcon className="h-5 w-5" />
                                                </IconButton>
                                            </Tooltip>
                                        )}
                                        <Tooltip content={ct('download')}>
                                            <Link onClick={(e) => handleDownload(e, file.file_name, file?.url)} >
                                                <img src={`/img/icons/downarrow.png`} alt='Downloadable' className="h-9 w-9 object-contain cursor-pointer" />
                                            </Link>
                                        </Tooltip>
                                        {hasDeletePermission && <div className="flex items-center space-x-2">
                                            <Popover
                                                isOpen={isPopoverOpen2.includes(index)}
                                                positions={['bottom', 'left']}
                                                padding={4}
                                                content={<div ref={popoverRef2} className="bg-white shadow-xl rounded-md w-40 flex flex-col z-50 border border-gray-100 py-1 break-words">
                                                    {hasDeletePermission && <button
                                                        className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                                        onClick={() => delete_rfq_file(index)}
                                                    >
                                                        <TrashIcon className="h-4 w-4 text-red-500"></TrashIcon>
                                                        {ct('delete')}
                                                    </button>}
                                                    {/* {file?.url && <button
                                                        className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                                        onClick={() => { setIsModalOpen(true); setDocumentUrl(file?.url) }}
                                                    >
                                                        <EyeIcon className="h-4 w-4 flex-shrink-0 text-gray-500 cursor-pointer hover:text-blue-600" />
                                                        {t('view_button')}
                                                    </button>} */}
                                                </div>}>
                                                <IconButton variant="text" color="blue-gray" onClick={() => openActionPopover2(index)}>
                                                    <EllipsisVerticalIcon className="h-6 w-6" />
                                                </IconButton>
                                            </Popover>
                                        </div>}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            }

            <div className="flex flex-col md:flex-row justify-between items-start gap-4 md:gap-2 px-4 md:px-6">
                <div className="flex items-center w-full md:flex-1">
                    {hasUpdatePermission && <input
                        type="checkbox"
                        disabled={isEditingRestricted}
                        className={`h-5 w-5 border-gray-300 rounded focus:ring-black ${
                            isEditingRestricted
                                ? 'cursor-not-allowed opacity-50'
                                : 'text-black cursor-pointer'
                        }`}
                        onChange={(e) => handleCheckAll(e)}
                        checked={isAllChecked}
                    />}
                    <Typography variant="h6" color="blue-gray" className="ml-2 mr-2">
                        {rfq_data?.type === 'custom' ? t('upload') : ''} {t('items_count_label', { count: rfq_products?.length || 'N/A' })}
                    </Typography>
                </div>
                <div className="flex w-full md:w-auto items-center gap-3 flex-wrap justify-between md:justify-end">

                    <Popover
                        isOpen={isSortingPopoverOpen}
                        positions={["bottom"]}
                        align="start"
                        padding={4}
                        onClickOutside={() => setIsSortingPopoverOpen(false)}
                        content={
                            <div className="bg-white shadow-xl rounded-md w-48 flex flex-col z-50 border border-gray-100 py-1">
                                <button
                                    onClick={() => {
                                        handelSorting("");
                                        setIsSortingPopoverOpen(false);
                                    }}
                                    className={`text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 ${sortingOrder === '' ? 'bg-gray-100 font-semibold' : ''}`}
                                >
                                    {t('sort_by_vat')}
                                </button>
                                {sorting_options?.map((option) => (
                                    <button
                                        key={option.value}
                                        onClick={() => {
                                            handelSorting(option.value);
                                            setIsSortingPopoverOpen(false);
                                        }}
                                        className={`text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 ${sortingOrder === option.value ? 'bg-gray-100 font-semibold' : ''}`}
                                    >
                                        {option.label}
                                    </button>
                                ))}
                            </div>
                        }
                    >

                        <Button
                            onClick={() => setIsSortingPopoverOpen(!isSortingPopoverOpen)}
                            variant="outlined"
                            className="flex items-center gap-2 border-gray-300 text-gray-800 capitalize font-medium"

                        >
                            <Bars3BottomLeftIcon className="h-4 w-4" />{sortingOrder !== '' && `(${(sorting_options.find(opt => opt.value === sortingOrder)?.label)?.replace('_', ' ')})`}
                        </Button>
                    </Popover>
                    {hasUpdatePermission 
                    && (userRole !== 'Sales Representative' || user?.parent_id == null)
                    && <Popover
                        isOpen={isCheckedItemPopoverOpen}
                        positions={["bottom"]}
                        align="start"
                        padding={4}
                        onClickOutside={() => setIsCheckedItemPopoverOpen(false)}
                        content={
                            <div className="bg-white shadow-xl rounded-md w-48 flex flex-col z-50 border border-gray-100 py-1">

                                {actionMenuOptions?.map((option) => (
                                    <button
                                        key={option.value}
                                        onClick={() => {
                                            handelCheckedItems(option.value);
                                        }}
                                        className="text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2 capitalize"
                                    >
                                        {option.label}
                                    </button>
                                ))}

                            </div>
                        }
                    >
                        <Button
                            onClick={() => setIsCheckedItemPopoverOpen(!isCheckedItemPopoverOpen)}
                            variant="outlined"
                            className="flex items-center gap-2 border-gray-300 capitalize font-bold bg-black text-white whitespace-nowrap"
                        >
                            {t('selected_items_button')}<ChevronDownIcon className="h-4 w-4" />
                        </Button>
                    </Popover>}
                    <div className="items-center gap-1">
                        <div className="flex -space-x-6" onClick={() => setIsMemberShow(true)}>

                            {rfq_data?.assigned_details?.filter(res => res.type !== "customer")?.map((res, index) => (
                                <Tooltip key={index} content={res?.assigned_to_name} placement="top">
                                    <img
                                        className="w-8 h-8 rounded-full border-2 border-white cursor-pointer"
                                        src={res?.assigned_to_profile_image}
                                        alt={res?.assigned_to_name}
                                    />
                                </Tooltip>
                            ))}

                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-10 md:gap-0 md:px-0">
                <table className="table-auto text-center whitespace-nowrap">
                    <thead>
                        <tr>
                            <th className="border-b border-blue-gray-50 py-3 px-2 text-left" colSpan={2}>
                                <Typography
                                    variant="small"
                                    className="text-[11px] font-bold text-black-gray"
                                >
                                    {t('add_item_instruction', { for_custom_order: rfq_data?.type === "custom" ? t('for_custom_order_text') : "" })}
                                    <a
                                        className={`border-b ${
                                            isEditingRestricted
                                                ? 'text-gray-400 cursor-not-allowed'
                                                : 'text-blue-600 hover:text-blue-800 cursor-pointer'
                                        }`}
                                        onClick={() => {
                                            if (!isEditingRestricted) addItem()
                                        }}
                                    >
                                        {t('add_item_button')}
                                    </a>
                                </Typography>
                            </th>
                            <th className="border-b border-blue-gray-50 py-3 px-2 text-left">
                                <Typography variant="small" className="text-[11px] font-bold text-black-gray"
                                >{t('is_installation_label')}
                                </Typography>
                            </th>
                            <th className="border-b border-blue-gray-50 py-3 px-2 text-left">
                                <Typography variant="small" className="text-[11px] font-bold text-black-gray"
                                >{t('installation_unit_label')}
                                </Typography>
                            </th>
                            <th className="border-b border-blue-gray-50 py-3 px-2 text-left">
                                <Typography variant="small" className="text-[11px] font-bold text-black-gray"
                                >{t('total_installation_label')}
                                </Typography>
                            </th>
                            <th className="border-b border-blue-gray-50 py-3 px-2 text-left">
                                <Typography variant="small" className="text-[11px] font-bold text-black-gray">
                                    {t('vat_percentage_label')}
                                </Typography>
                            </th>
                            <th className="border-b border-blue-gray-50 py-3 px-2 text-left">
                                <Typography variant="small" className="text-[11px] font-bold text-black-gray">
                                    {t('vat_sar_label')}
                                </Typography>
                                <Typography variant="small" className="text-[10px] font-normal text-blue-gray-500 block mt-0.5">
                                    {rfq_summary?.is_vat_charge === "yes" ? t('applied_on_rfq_note') : t('if_vat_on_note')}
                                </Typography>
                            </th>
                            {hasViewProductPurchasePricePermission &&
                                <th className="border-b border-blue-gray-50 py-3 px-2 text-left">
                                    <Typography variant="small" className="text-[11px] font-bold text-black-gray"
                                    >{t('purchase_price_label')}
                                    </Typography>
                                </th>
                            }
                            {hasViewProductSalePricePermission &&
                                <th className="border-b border-blue-gray-50 py-3 px-2 text-left">
                                    <Typography variant="small" className="text-[11px] font-bold text-black-gray"
                                    >{t('sale_price_label')}
                                    </Typography>
                                </th>
                            }
                            <th className="border-b border-blue-gray-50 py-3 px-2 text-left">
                                <Typography variant="small" className="text-[11px] font-bold text-black-gray">
                                    {t('total_amount_label')}
                                </Typography>
                            </th>
                            <th className="border-b border-blue-gray-50 py-3 px-2 text-left">
                                <Typography variant="small" className="text-[11px] font-bold text-black-gray"
                                >{t('vendors_price_label')}
                                </Typography>
                            </th>
                            <th className="border-b border-blue-gray-50 py-3 px-2 text-left">
                                <Typography variant="small" className="text-[11px] font-bold text-black-gray"
                                >{t('margin_label')}
                                </Typography>
                            </th>
                            <th className="border-b border-blue-gray-50 py-3 px-2 text-left">
                                <Typography variant="small" className="text-[11px] font-bold text-black-gray"
                                >{t('discount_label')}
                                </Typography>
                            </th>
                            <th className="border-b border-blue-gray-50 py-3 px-2 text-left">
                                <Typography variant="small" className="text-[11px] font-bold text-black-gray"
                                >{t('customer_price_label')}
                                </Typography>
                            </th>

                            <th className="border-b border-blue-gray-50 py-3 px-2 text-left"></th>
                        </tr>
                    </thead>
                    <tbody>

                        {list_loading ? <tr><td colSpan={14} className="text-center"> <div role="status">
                            <svg aria-hidden="true" className="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-green-500" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                            </svg>
                        </div></td></tr> : ''}

                        {!list_loading && rfq_products?.length === 0 && (
                            <tr><td colSpan={14} className="text-center py-10 text-blue-gray-500">{t("noDataFound")}</td></tr>
                        )}

                        {rfq_products?.length > 0 && <>
                            {rfq_products.map((item, index) => {
                                const className = `py-3 px-5 ${index === rfq_products?.length - 1
                                    ? ""
                                    : "border-b border-blue-gray-50"
                                    }`;
                                const matchedColor = item?.product?.product_varients?.find(
                                    v => v.color_id === item.attribute_value_color_id
                                );

                                const matchedSize = matchedColor?.sizes?.find(
                                    s => s.size_id === item.attribute_value_size_id
                                )
                                return (
                                    <tr
                                        key={index}
                                        className="border-b hover:bg-gray-50 transition"
                                    >
                                        {/* Product info */}
                                        <td className={className}>
                                            <div className="flex items-center gap-5">
                                                {hasUpdatePermission && <input type="checkbox"
                                                    disabled={isEditingRestricted}
                                                    className={`h-5 w-5 rounded focus:ring-black ${
                                                        isEditingRestricted
                                                            ? 'cursor-not-allowed opacity-50 border-gray-200 bg-gray-100'
                                                            : 'text-black border-gray-300 cursor-pointer'
                                                    }`}
                                                    onChange={() => handleSingleCheck(item?.id)}
                                                    checked={checkedItems.includes(item?.id)}
                                                />}
                                                <div className="w-10 h-10 bg-gray-100 border rounded flex items-center justify-center">
                                                    <Avatar
                                                        src={item?.product_image ?? "/img/photo-gallery.png"}
                                                        alt={item?.product?.name}
                                                        size="sm"
                                                        variant="rounded"
                                                    />
                                                </div>
                                                <div className="min-w-[100px]">
                                                    <Typography variant="small" color="blue-gray" className="font-semibold"
                                                    >SKU {item?.product?.sku_number}
                                                    </Typography>
                                                    <Typography className="text-xs font-normal text-blue-gray-500">
                                                        {item?.product?.name}
                                                    </Typography>
                                                </div>
                                                {matchedColor && matchedSize && (
                                                    <div className="flex gap-2">
                                                        {/* Color */}
                                                        <div className="flex items-center gap-2">
                                                            <span
                                                                className="w-4 h-4 rounded-full border border-gray-400 shadow-sm"
                                                                style={{ backgroundColor: matchedColor.color_hex }}
                                                            ></span>
                                                        </div>
                                                        {/* Size */}
                                                        <div className="flex justify-between">
                                                            <span>{matchedSize.size}</span>
                                                        </div>

                                                    </div>
                                                )}
                                            </div>
                                        </td>

                                        {/* Quantity */}
                                        <td className={className}>
                                            <div className="flex justify-center items-center gap-1">
                                                <button
                                                    onClick={() => {
                                                       if (!isEditingRestricted) handleQuantityChange(item?.id, item.quantity, -1, item)
                                                       }
                                                    }
                                                    className="p-1 bg-gray-300 rounded-lg"
                                                    disabled={item.quantity <= 1}
                                                >
                                                    <MinusIcon className="h-4 w-4" />
                                                </button>

                                                <span className="inline-flex items-center">
                                                    <input
                                                        type="number"
                                                        value={productQuantity[item?.id] ?? item.quantity}
                                                        className={`w-14 px-2 py-1 border rounded-md text-center text-sm focus:outline-none focus:ring-1 appearance-none ${
                                                            isEditingRestricted
                                                                ? 'cursor-not-allowed opacity-50 bg-gray-100 border-gray-200'
                                                                : 'border-gray-300 focus:ring-blue-500'
                                                        }`}
                                                        disabled={isEditingRestricted}
                                                        min={1}
                                                        onWheel={(e) => e.target.blur()}
                                                        onChange={(e) => {
                                                            const raw = e.target.value;
                                                            const parsed = Number(raw);
                                                            if (!Number.isNaN(parsed) && parsed >= 1) {
                                                                setProductQuantity((prev) => ({
                                                                    ...prev,
                                                                    [item?.id]: parsed,
                                                                }));
                                                            } else if (raw === "") {
                                                                // Allow clearing while typing; don't update quantity yet
                                                                setProductQuantity((prev) => ({
                                                                    ...prev,
                                                                    [item?.id]: "",
                                                                }));
                                                            }
                                                        }}
                                                        readOnly={rfq_details?.customer_approval === 'yes'}
                                                        onBlur={() => {
                                                            const edited = productQuantity[item?.id];
                                                            const newQty =
                                                                edited === "" || edited == null
                                                                    ? item.quantity
                                                                    : Number(edited);

                                                            if (!Number.isNaN(newQty) && newQty !== item.quantity) {
                                                                updateQuantity(item?.id, newQty, item);
                                                            }
                                                        }}
                                                    />


                                                </span>

                                                <button
                                                    onClick={() => {
                                                        if (!isEditingRestricted) handleQuantityChange(item?.id, item.quantity, 1, item)
                                                        }
                                                    }
                                                    className={`p-1 text-white rounded-lg ${
                                                        isEditingRestricted
                                                            ? 'bg-gray-300 cursor-not-allowed opacity-50'
                                                            : 'bg-blue-500 hover:bg-blue-600 cursor-pointer'
                                                    }`}
                                                >
                                                    <PlusIcon className="h-4 w-4" />
                                                </button>
                                            </div>
                                        </td>

                                        <td className={className}>
                                            {hasUpdatePermission && <input type="checkbox"
                                                disabled={isEditingRestricted}
                                                checked={item?.is_installation === 'yes'}
                                                className={`w-4 h-4 accent-[#000000] ${
                                                    isEditingRestricted
                                                        ? 'cursor-not-allowed opacity-50'
                                                        : 'cursor-pointer'
                                                }`}
                                                onClick={(e) => isInstallationCharge(e, item?.id)}
                                            />}
                                        </td>
                                        <td className={className}><Typography className="text-xs font-normal text-blue-gray-500">{item?.product?.rfq_currency_code} {item?.product?.rfq_installation_charge || '_'}</Typography></td>
                                        <td className={className}><Typography className="text-xs font-normal text-blue-gray-500">{item?.product?.rfq_currency_code} {item?.product?.total_installation_charge || '_'}</Typography></td>

                                        <td className={className}>
                                            <Typography className="text-xs font-normal text-blue-gray-500">
                                                {item?.product?.vat_tax != null && item?.product?.vat_tax !== ""
                                                    ? `${item.product.vat_tax}%`
                                                    : "_"}
                                            </Typography>
                                        </td>
                                        <td className={className}>
                                            <Typography className="text-xs font-semibold text-blue-gray-800">
                                                {rfq_summary?.is_vat_charge === "yes" &&
                                                    item?.vat_amount
                                                    ? item?.product?.rfq_currency_code + " " + item?.vat_amount
                                                    : "—"}
                                            </Typography>
                                        </td>
                                        {hasViewProductPurchasePricePermission &&
                                            <td className={className}><Typography className="text-xs font-normal text-blue-gray-500">{item?.product?.rfq_currency_code} {item?.unit_price}</Typography></td>
                                        }
                                        {hasViewProductSalePricePermission &&
                                            <td className={className}><Typography className="text-xs font-normal text-blue-gray-500">{item?.product?.rfq_currency_code} {item?.sale_price}</Typography></td>
                                        }
                                        <td className={className}><Typography className="text-xs font-normal text-blue-gray-500">{item?.product?.rfq_currency_code} {item?.total_amount}</Typography></td>

                                        <td className={`${className}`}>
                                            <Typography className="text-xs font-normal text-blue-gray-500">
                                                {item?.vendor_price ? item?.product?.rfq_currency_code + " " + item?.vendor_price :
                                                    <PlusIcon className="h-4 w-4" />
                                                }
                                            </Typography>
                                        </td>
                                        <td className={className}>
                                            <div className="flex flex-col gap-1 py-1">
                                                <div className="flex items-center gap-2">
                                                    <Typography className="text-[11px] font-medium text-blue-gray-500 capitalize">
                                                        {t('flat_label')}
                                                    </Typography>
                                                    <Typography className="text-sm font-semibold text-gray-900">
                                                        {item?.flat_margin || '0.00'}
                                                    </Typography>
                                                </div>
                                                <div className="flex items-center gap-2">
                                                    <Typography className="text-[11px] font-medium text-blue-gray-500 mt-1 capitalize">
                                                        {t('percentage_label')}
                                                    </Typography>
                                                    <Typography className="text-sm font-semibold text-gray-900">
                                                        {item?.percentage_margin || '0'}%
                                                    </Typography>
                                                </div>

                                            </div>
                                        </td>
                                        <td className={className}>
                                            <div className="flex flex-col gap-1 py-1">
                                                <div className="flex items-center gap-2">
                                                    <Typography className="text-[11px] font-medium text-blue-gray-500 capitalize">
                                                        {t('flat_label')}
                                                    </Typography>
                                                    <Typography className="text-sm font-semibold text-gray-900">
                                                        {item?.flat_discount || '0.00'}
                                                    </Typography>
                                                </div>
                                                <div className="flex items-center gap-2">
                                                    <Typography className="text-[11px] font-medium text-blue-gray-500 mt-1 capitalize">
                                                        {t('percentage_label')}
                                                    </Typography>
                                                    <Typography className="text-sm font-semibold text-gray-900">
                                                        {item?.percentage_discount || '0'}%
                                                    </Typography>
                                                </div>

                                            </div>
                                        </td>
                                        <td className={className}>
                                            <div className="flex flex-col gap-1 py-1">
                                                <div className="flex items-center gap-2">
                                                    <Typography className="text-[11px] font-medium text-blue-gray-500">
                                                        {item?.product?.rfq_currency_code}
                                                    </Typography>
                                                    <Typography className="text-base font-bold text-gray-900">
                                                        {item?.customer_price || item?.sale_price || t('na')}
                                                    </Typography>
                                                </div>



                                            </div>
                                        </td>

                                        <td className={className}>
                                            {(((hasDeletePermission || hasUpdatePermission) && rfq_details?.customer_approval !== 'yes') || (hasViewVendorPermission || hasEditVendorPermission)) && <div className="flex items-center space-x-2">
                                                <Popover
                                                    isOpen={isPopoverOpen.includes(item?.id)}
                                                    positions={['bottom', 'left']}
                                                    padding={4}
                                                    content={<div ref={popoverRef} className="bg-white shadow-xl rounded-md w-40 flex flex-col z-50 border border-gray-100 py-1 break-words">

                                                        {hasDeletePermission && <button
                                                            className={`flex items-center gap-2 text-left text-sm px-3 py-2 ${
                                                                isEditingRestricted
                                                                    ? 'text-gray-400 cursor-not-allowed opacity-50'
                                                                    : 'text-gray-700 hover:bg-gray-100 cursor-pointer'
                                                            }`}
                                                            onClick={() => delete_item(item?.id)}
                                                            disabled={isEditingRestricted}
                                                        >
                                                            <TrashIcon className="h-4 w-4 text-red-500" />
                                                            {ct('delete')}
                                                        </button>}
                                                        {hasUpdatePermission && rfq_details?.customer_approval !== 'yes' && <button
                                                            className={`flex items-center gap-2 text-left text-sm px-3 py-2 ${
                                                                isEditingRestricted
                                                                    ? 'text-gray-400 cursor-not-allowed opacity-50'
                                                                    : 'text-gray-700 hover:bg-gray-100 cursor-pointer'
                                                            }`}
                                                            onClick={() => openUpdateModal(item)}
                                                            disabled={isEditingRestricted}
                                                        >
                                                            <CurrencyRupeeIcon className="h-4 w-4 text-green-500" />
                                                            {t('edit_pricing_button')}
                                                        </button>}
                                                        {hasViewVendorPermission && <button
                                                            className="flex items-center gap-2 text-left text-sm text-gray-700 hover:bg-gray-100 px-3 py-2"
                                                            onClick={() => setOpenModalViewVendor(item)}
                                                        >
                                                            <EyeIcon className="h-4 w-4 text-green-500" />
                                                            {t('view_vendor_button_popover')}
                                                        </button>}
                                                        {hasEditVendorPermission && <button
                                                            className={`flex items-center gap-2 text-left text-sm px-3 py-2 ${
                                                                isEditingRestricted
                                                                    ? 'text-gray-400 cursor-not-allowed opacity-50'
                                                                    : 'text-gray-700 hover:bg-gray-100 cursor-pointer'
                                                            }`}
                                                            onClick={() => setOpenModalEditVendor(item)}
                                                            disabled={isEditingRestricted}
                                                        >
                                                            <PencilSquareIcon className="h-4 w-4 text-green-500" />
                                                            {t('add_edit_vendor_button')}
                                                        </button>}
                                                    </div>}>
                                                    <IconButton variant="text" color="blue-gray" onClick={() => openActionPopover(item?.id)}>
                                                        <EllipsisVerticalIcon className="h-6 w-6" />
                                                    </IconButton>
                                                </Popover>
                                            </div>}
                                        </td>
                                    </tr>
                                )
                            }
                            )}
                        </>
                        }
                    </tbody>
                </table>
            </div>
            {isModalOpen && <DocumentViewModal documentUrl={documentUrl} setIsDocumentViewModalOpen={setIsModalOpen}></DocumentViewModal>}
            {openModalEditVendor && (
                <VendorVarientPriceModal
                    onClose={() => {
                        setOpenModalEditVendor(false);
                        dispatch(fetchRFQProduct({ rfq_id: rfq_id, search: search, sort_order: sortingOrder }));
                    }}
                    item={openModalEditVendor}
                    rfq_id={rfq_id}
                />
            )}
            {openModalViewVendor && (
                <ViewVendorVarientPriceModal
                    onClose={() => {
                        setOpenModalViewVendor(false);
                        dispatch(fetchRFQProduct({ rfq_id: rfq_id, search: search, sort_order: sortingOrder }));
                    }}
                    item={openModalViewVendor}
                    rfq_id={rfq_id}
                />
            )}

            {selectedItemData && (
                <UpdatePriceModal
                    isOpen={selectedItemData !== null ? true : false}
                    onClose={closeUpdateModal}
                    itemData={selectedItemData}
                    rfq_id={rfq_id}
                />
            )}

            {isMemberShow && <ViewAssignedMembers onClose={() => setIsMemberShow(false)} rfq_id={rfq_details?.id} order_id={null} />}

        </div>

    )
}

export default RfqItems
